export default {
  TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING(state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, { token, expiresIn }) {
    state.token = token
    state.tokenExpiration = expiresIn // Almacena el tiempo de expiración en segundos
    //console.log('Token y tiempo de expiración almacenados en localStorage:', token, expiresIn);
  },
  enviarCorreo(state, value) {
    state.userMail = value
    // Almacenar en el almacenamiento local
    localStorage.setItem('userMail', value)
  },

  
  // Dni y nombres obtenidos de la 2da Api del Login
  SET_DNI(state, dni) {
    state.dni = dni
  },
  SET_NOMBRES(state, nombres) {
    state.nombres = nombres
  },
  // Datos de la API con los roles
  SET_USER_ROL(state, userRol) {
    //console.log('userRol:', userRol);
    state.userRol = userRol
  },

  // Nueva mutación para limpiar los datos de la API de usuario y roles
  CLEAR_USER_DATA(state) {
    state.dni = null
    state.nombres = null
    state.userRol = null
    // Eliminar datos del usuario del almacenamiento local
    localStorage.removeItem('userData')
    localStorage.removeItem('userRolData')
  }

};



// WEBPACK FOOTER //
// ./src/store/mutations.js